import { useCurrentUser } from '../../currentUser/model/useCurrentUser';
import { useTrialPaywallVariantStore } from './useTrialPaywallVariantStore';

type TrialPaywallPending = {
  isPending: boolean;
  markShown: () => void;
};

export const useTrialPaywallPending = (): TrialPaywallPending => {
  const assignment = useTrialPaywallVariantStore((state) => state.assignment);
  const isPaywallShown = useTrialPaywallVariantStore((state) => state.isPaywallShown);
  const markShown = useTrialPaywallVariantStore((state) => state.markPaywallShown);
  const { data: userId } = useCurrentUser((user) => user.id);

  const isPending = !isPaywallShown && Boolean(userId) && assignment?.userId === userId && assignment?.variant === 'B';

  return { isPending, markShown };
};
